// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/frontend/" + chunkId + ".js?id=" + {"369":"644adeeb2bc3dd72","478":"79c122721b9fa805","716":"706a53ac388001c3","920":"5b6b7454de86b172"}[chunkId] + "";
};